import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  getAllRecordedVideosApi,
  deleteRecordedVideoApi,
  getRecordedVideoBinApi,
  restoreRecordedVideoApi,
} from "../../Constants/api";
import SweetAlert from "react-bootstrap-sweetalert";
import Table from "../../../../../../Components/Table";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import ReactPlayer from "react-player";

const AllRecordedSessions = () => {
  const [data, setData] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsCountPerPage, setItemsCountPerPage] = useState(10);
  const [alert, setAlert] = useState(null);
  const [isBin, setIsBin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [activeVideoUrl, setActiveVideoUrl] = useState("");
  const history = useHistory();

  const toggleModal = () => setModal(!modal);

  const openVideoModal = (url) => {
    setActiveVideoUrl(url);
    setModal(true);
  };

  const fetchData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);
    try {
      const response = isBin
        ? await getRecordedVideoBinApi(page, sizePerPage)
        : await getAllRecordedVideosApi(page, sizePerPage);

      if (response?.data) {
        setData(response.data.data || []);
        setTotalItems(response.data.count || 0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData(activePage, itemsCountPerPage);
  }, [activePage, itemsCountPerPage, isBin]);

  const handleTableChange = (type, { page, sizePerPage }) => {
    setActivePage(page);
    setItemsCountPerPage(sizePerPage);
  };

  const handleDelete = async (id) => {
    try {
      await deleteRecordedVideoApi(id);
      setAlert(
        <SweetAlert
          success
          title="Deleted!"
          onConfirm={() => {
            setAlert(null);
            fetchData(activePage, itemsCountPerPage);
          }}
        >
          Session has been deleted.
        </SweetAlert>
      );
    } catch (error) {
      console.error("Error deleting:", error);
      setAlert(
        <SweetAlert
          danger
          title="Error!"
          onConfirm={() => setAlert(null)}
        >
          Something went wrong.
        </SweetAlert>
      );
    }
  };

  const handleRestore = async (id) => {
    try {
      await restoreRecordedVideoApi(id);
      setAlert(
        <SweetAlert
          success
          title="Restored!"
          onConfirm={() => {
            setAlert(null);
            fetchData(activePage, itemsCountPerPage);
          }}
        >
          Session has been restored.
        </SweetAlert>
      );
    } catch (error) {
      console.error("Error restoring:", error);
      setAlert(
        <SweetAlert
          danger
          title="Error!"
          onConfirm={() => setAlert(null)}
        >
          Something went wrong.
        </SweetAlert>
      );
    }
  };


  const confirmDelete = (id) => {
    setAlert(
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Yes, delete it!"
        confirmBtnBsStyle="danger"
        title="Are you sure?"
        onConfirm={() => handleDelete(id)}
        onCancel={() => setAlert(null)}
        focusCancelBtn
      >
        You will not be able to recover this session!
      </SweetAlert>
    );
  };

  const confirmRestore = (id) => {
    setAlert(
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Yes, restore it!"
        confirmBtnBsStyle="success"
        title="Are you sure?"
        onConfirm={() => handleRestore(id)}
        onCancel={() => setAlert(null)}
        focusCancelBtn
      >
        You want to restore this session!
      </SweetAlert>
    );
  };


  const columns = [
    {
      text: "S.No",
      dataField: "sno",
      formatter: (cell, row, rowIndex) => {
        return (activePage - 1) * itemsCountPerPage + rowIndex + 1;
      },
    },
    {
      text: "Thumbnail",
      dataField: "thumbnailImage",
      formatter: (cell, row) => (
        <img
          src={cell}
          alt={row.title}
          style={{ width: "50px", height: "50px", objectFit: "cover" }}
        />
      ),
    },
    {
      text: "Title",
      dataField: "title",
      formatter: (cell) => cell?.length > 10 ? cell.substring(0, 10) + "..." : cell
    },
    {
      text: "URL",
      dataField: "Url",
      formatter: (cell) => (
        <button
          className="btn btn-outline-info btn-sm"
          onClick={() => openVideoModal(cell)}
        >
          <i className="ri-play-fill mr-1"></i> Play
        </button>
      )
    },
    {
      text: "Duration",
      dataField: "duration",
      formatter: (cell) => {
        if (!cell) return "-";
        const mins = Math.floor(cell / 60);
        const secs = cell % 60;
        return `${mins}:${secs.toString().padStart(2, '0')} min`;
      }
    },
    {
      text: "Actions",
      dataField: "actions",
      formatter: (cell, row) => (
        <div>
          {!isBin ? (
            <>
              <button
                className="btn btn-primary btn-sm mr-2"
                onClick={() => history.push(`/dashboard/recorded-sessions/edit/${row._id}`)}
              >
                Edit
              </button>
              <button
                className="btn btn-danger btn-sm"
                onClick={() => confirmDelete(row._id)}
              >
                Delete
              </button>
            </>
          ) : (
            <button
              className="btn btn-success btn-sm"
              onClick={() => confirmRestore(row._id)}
            >
              Restore
            </button>
          )}

        </div>
      ),
    },
  ];

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h3>{isBin ? "Recorded Session Bin" : "All Recorded Sessions"}</h3>
        <div>
          <button className={`btn ${isBin ? 'btn-secondary' : 'btn-info'} mr-2`} onClick={() => { setIsBin(!isBin); setActivePage(1); }}>
            {isBin ? "View Active" : "View Bin"}
          </button>
          {!isBin && (
            <Link to="/dashboard/recorded-sessions/create" className="btn btn-warning">
              Create New
            </Link>
          )}
        </div>
      </div>
      <div className="card-body">
        <Table
          rows={data}
          columns={columns}
          page={activePage}
          sizePerPage={itemsCountPerPage}
          totalSize={totalItems}
          onTableChange={handleTableChange}
          isLoading={isLoading}
        />
      </div>
      {alert}

      <Modal isOpen={modal} toggle={toggleModal} size="lg" centered>
        <ModalHeader toggle={toggleModal}>Video Preview</ModalHeader>
        <ModalBody className="p-0">
          <div className="embed-responsive embed-responsive-16by9 bg-dark">
            <ReactPlayer
              url={activeVideoUrl}
              width="100%"
              height="100%"
              controls={true}
              playing={modal}
            />
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default AllRecordedSessions;
